import React from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";

export const ExportButtons = ({
  handleExport,
  isExporting,
  exportingType,
  data,
  error,
}) => {
  const isDisabled = isExporting || !data.length || !!error;

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      flexWrap="wrap"
      sx={{
        p: 2,
        borderBottom: "1px solid #E5E7EB",
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="subtitle1" fontWeight="bold">
        Export as:
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ minWidth: 100 }}
        onClick={() => handleExport("csv")}
        disabled={isDisabled}
        startIcon={
          isExporting && exportingType === "csv" ? (
            <CircularProgress size={16} />
          ) : null
        }
      >
        CSV
      </Button>
      <Button
        variant="contained"
        color="primary"
        sx={{ minWidth: 100 }}
        onClick={() => handleExport("excel")}
        disabled={isDisabled}
        startIcon={
          isExporting && exportingType === "excel" ? (
            <CircularProgress size={16} />
          ) : null
        }
      >
        EXCEL
      </Button>
      <Button
        variant="contained"
        color="primary"
        sx={{ minWidth: 100 }}
        onClick={() => handleExport("txt")}
        disabled={isDisabled}
        startIcon={
          isExporting && exportingType === "txt" ? (
            <CircularProgress size={16} />
          ) : null
        }
      >
        TXT
      </Button>
    </Box>
  );
};
